/* DRIP DROP — carrello, toast, countdown */
(function(){
  if(window.__ddLoaded)return;window.__ddLoaded=true;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function toast(msg){
    var t=document.querySelector('.dd-toast');
    if(!t){t=document.createElement('div');t.className='dd-toast';t.setAttribute('role','status');document.body.appendChild(t);}
    t.innerHTML='';var s=document.createElement('span');s.textContent=msg;t.appendChild(s);
    var a=document.createElement('a');a.href=root+'cart';a.textContent='Vai al carrello';t.appendChild(a);
    t.hidden=false;clearTimeout(t._h);t._h=setTimeout(function(){t.hidden=true},4000);
  }
  function refreshCount(){
    fetch(root+'cart.js').then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('.cart-count,[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=c.item_count<1});
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:c}));
    }).catch(function(){});
  }
  window.ddAdd=function(items,label,btn){
    if(btn){btn.disabled=true;btn._t=btn.textContent;btn.textContent='Aggiungo…';}
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Errore')});return r.json()})
      .then(function(){toast(label||'Aggiunto al carrello');refreshCount();if(window.dataLayer){dataLayer.push({event:'add_to_cart'})}})
      .catch(function(e){toast(e.message||'Non disponibile, scegli un\'altra taglia')})
      .finally(function(){if(btn){btn.disabled=false;btn.textContent=btn._t}});
  };
  // quick add sulle card
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-dd-quick]');if(!b)return;e.preventDefault();
    ddAdd([{id:Number(b.getAttribute('data-dd-quick')),quantity:1}],'Taglia '+b.textContent.trim()+' aggiunta',null);
  });
  // countdown al prossimo drop
  document.querySelectorAll('[data-dd-count]').forEach(function(el){
    var day=Number(el.getAttribute('data-day')),hour=Number(el.getAttribute('data-hour'));
    function next(){var n=new Date(),t=new Date(n);t.setHours(hour,0,0,0);var add=(day-n.getDay()+7)%7;if(add===0&&t<=n)add=7;t.setDate(n.getDate()+add);return t}
    function pad(x){return String(x).padStart(2,'0')}
    function tick(){var d=next()-new Date();var s=Math.floor(d/1000);
      el.querySelector('[data-d]').textContent=pad(Math.floor(s/86400));
      el.querySelector('[data-h]').textContent=pad(Math.floor(s%86400/3600));
      el.querySelector('[data-m]').textContent=pad(Math.floor(s%3600/60));}
    tick();setInterval(tick,30000);
  });
})();
